import { render } from "./AlignJustify.vue?vue&type=template&id=3f605f2e&scoped=true"
const script = {}

import "./AlignJustify.vue?vue&type=style&index=0&id=3f605f2e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f605f2e"]])

export default __exports__